export default __webpack_public_path__ + "static/getting-started-79ffbcb61565006b0fe4e4e008c5ceb1.svg";